export const fileTypes = ['audio', 'file', 'image', 'video'] as const
export type FileType = (typeof fileTypes)[number]

export const isFileType = (type: string): type is FileType => {
  return fileTypes.includes(type as FileType)
}
